var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRegularSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6074 5.99977C10.6074 6.31148 10.3446 6.56227 10.0181 6.56227H6.0895V10.3123C6.0895 10.6228 5.82554 10.875 5.50021 10.875C5.17487 10.875 4.91092 10.624 4.91092 10.3123V6.56227H0.982352C0.657017 6.56227 0.393066 6.31055 0.393066 6C0.393066 5.69039 0.657017 5.43727 0.982352 5.43727H4.91092V1.68727C4.91092 1.37672 5.17487 1.125 5.50021 1.125C5.82554 1.125 6.0895 1.37672 6.0895 1.68727V5.43727H10.0181C10.3446 5.43727 10.6074 5.69039 10.6074 5.99977Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRegularSm);
export default __webpack_public_path__ + "static/media/plus-regular-sm.267e02681afc6dae70053eabc303b0d1.svg";
export { ForwardRef as ReactComponent };